import { useAppSelector } from "../hooks";

export const useGetStarted = () => {
  const { data, meta, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.started
  );

  return {
    data,
    meta,
    status,
  };
};

export const useGetCompleted = () => {
  const { data, meta, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.completed
  );

  return {
    data,
    meta,
    status,
  };
};

export const useGetFavorite = () => {
  const { data, meta, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.favorite
  );

  return {
    data,
    meta,
    status,
  };
};

export const useGetBookmarked = () => {
  const { data, meta, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.bookmarked
  );

  return {
    data,
    meta,
    status,
  };
};

export const useGetHighlighted = () => {
  const { data, meta, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.highlighted
  );

  return {
    data,
    meta,
    status,
  };
};

export const useGetBookmarkedDetails = () => {
  const { data, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.bookmarkedDetails
  );

  return {
    data,
    status,
  };
};

export const useGetHighlightedDetails = () => {
  const { data, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.highlightedDetails
  );

  return {
    data,
    status,
  };
};

export const useGetMyPlaylists = () => {
  const { data, meta, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.paginatedplaylists
  );

  return {
    data,
    meta,
    status,
  };
};
